import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent, FormControl,
    FormControlLabel, IconButton, InputLabel, MenuItem,
    Paper, Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField, Tooltip
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./AddEmployeeForm.css";
import LoaderCustomFixed from "../../../components/ConfirmationModal/LoaderCustomFixed";
import HeaderGenerator from "./HeaderGenerator";
import JoditEditor from "jodit-react";
import DepartmentEnumWithoutLegal from "../../../enums/DepartmentEnumWithoutLegal";
import OrderDecisionEnum from "../../../enums/orderDecisionEnum";
import TemplateEnum from "../../../enums/templateEnum";
import {MdDelete, MdEdit} from "react-icons/md";
import {HiOutlineClipboardDocument} from "react-icons/hi2";
import InstructionsBox from "./InstructionsBox";


const AddNewDocumentTypeForm = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [documentTypes, setDocumentTypes] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteDocumentTypeId, setDeleteDocumentTypeId] = useState(null);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [loading, setLoading] = useState(true);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [currentDocumentType, setCurrentDocumentType] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [editSkipVisage, setEditSkipVisage] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [docTypeToCopy, setDocTypeToCopy] = useState(null);
    const [isDocCopyModalOpen, setIsDocCopyModalOpen] = useState(false);

    const handleContentChange = (newContent) => {
        const sylfaenContent = newContent.replace(/font-family:[^;]+;/g, 'font-family: Sylfaen;');
        setCurrentDocumentType({
            ...currentDocumentType,
            textHTML: sylfaenContent
        });
    };

    const TemplateOptions = [
        {id: null, name: 'შაბლონის გარეშე'},
        {id: TemplateEnum.order, name: 'ბრძანება'},
        {id: TemplateEnum.letter, name: 'წერილი'},
        {id: TemplateEnum.insideLetter, name: 'სამსახურეობრივი ბარათი'},
    ];

    const getDepartmentNames = (departmentIds) => {
        if (!departmentIds) return <div></div>;

        return departmentIds.map(departmentId => (
            <div key={departmentId}>
                • {Object.values(DepartmentEnumWithoutLegal).find(dept => dept.id === departmentId)?.name || ''}
            </div>
        ));
    };


    const handleCheckboxChange = (id) => {
        setSelectedDepartments(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };


    const handelSkipVisageChange = (event) => {
        setEditSkipVisage(event.target.checked);
    };
    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა",

    };

    const config = {
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 800,
        width: 798,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };


    const openEditModal = (documentType) => {
        setCurrentDocumentType(documentType);
        setIsEditModalOpen(true);
        setSelectedDepartments(documentType.departamentIds || []);
        setEditSkipVisage(documentType.skipVisage || false);
    };

    const copyDocument = async (documentType) => {
        // Filter to find documents with similar names
        const baseName = documentType.name.replace(/\s\(\d+\)$/, "");

        // Filter to find all documents that start with the base name and end with a pattern like " (number)"
        const documentsWithSimilarName = documentTypes.filter(doc =>
            new RegExp(`^${baseName} \\(\\d+\\)$`).test(doc.name)
        );

        // Extract the numbers used in similar names to find the max number
        const numbers = documentsWithSimilarName.map(doc => {
            const match = doc.name.match(/\((\d+)\)$/);
            return match ? parseInt(match[1], 10) : 0;
        });
        const maxNumber = numbers.length > 0 ? Math.max(...numbers) : 0;

        const newDocumentType = {
            ...documentType,
            name: `${baseName} (${maxNumber + 1})`, // Appending next available number
            description: documentType.description || "string",
            permitTypeId: documentType.permitTypeId,
            blank: documentType.blank,
            approvalDocument: documentType.approvalDocument,
            documentTypeStatus: documentType.documentTypeStatus,
            textHTML: documentType.textHTML || "string",
            departamentIds: documentType.departamentIds,
            orderDecision: documentType.orderDecision || 0,
            templateType: documentType.templateType || 0
        };

        const apiUrl = `${baseURL}/AddNewDocumentType`;

        try {
            const response = await axios.post(apiUrl, newDocumentType);
            if (response.data.success) {
                await fetchDocumentTypes();
                setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
            } else {
                setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით!', type: 'error'})
            }
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით!', type: 'error'});
        } finally {
            setIsDocCopyModalOpen(false)
        }
    };


    useEffect(() => {
        void fetchDocumentTypes();
    }, []);

    const prepareContent = (content) => {
        return content.replace(/font-family:.*?;/g, 'font-family: Sylfaen;');
    };

    const refreshFiles = () => {
        void fetchDocumentTypes();
    };


    const handleUpdateDocumentType = async () => {
        if (currentDocumentType) {

            const cleanedContent = prepareContent(currentDocumentType.textHTML);

            setIsSubmitting(true); // Start showing the loader
            const updatedData = {
                id: currentDocumentType.id,
                name: currentDocumentType.name,
                desctiption: currentDocumentType.desctiption,
                permitTypeId: currentDocumentType.permitTypeId,
                blank: currentDocumentType.blank,
                approvalDocument: currentDocumentType.approvalDocument,
                documentTypeStatus: currentDocumentType.documentTypeStatus,
                textHTML: cleanedContent,
                departamentIds: selectedDepartments,
                orderDecision: currentDocumentType.orderDecision ? currentDocumentType.orderDecision : 14,
                templateType: currentDocumentType.orderDecision ? currentDocumentType.orderDecision : null,
                skipVisage: editSkipVisage
            };

            try {
                await axios.put(`${baseURL}/EditDocumentType`, updatedData);
                setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
                await fetchDocumentTypes();
            } catch (error) {
                setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით!', type: 'error'});
            } finally {
                setIsSubmitting(false);
                setIsEditModalOpen(false);
            }
        }
    };


    const fetchDocumentTypes = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseURL}/GetAllDocumentType`);
            if (response.data && response.data.data) {
                const filteredDocumentTypes = response.data.data.reverse();
                setDocumentTypes(filteredDocumentTypes);
            } else {
                setDocumentTypes([]);
            }
        } catch (error) {
            setDocumentTypes([]);
        } finally {
            setLoading(false);
        }
    };


    const handleDeleteConfirm = async () => {
        try {
            await axios.put(`${baseURL}/DeleteDocumentType`, {id: deleteDocumentTypeId}, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            await fetchDocumentTypes();
            setIsDeleteModalOpen(false);
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        }
    };


    const openDeleteModal = (documentTypeId) => {
        setDeleteDocumentTypeId(documentTypeId);
        setIsDeleteModalOpen(true);
    };


    return (
        <div className="add-dov-type-form">
            <div style={{marginTop: 50, paddingLeft: "3%", paddingRight: "3%"}}>
                <HeaderGenerator onFileAdded={refreshFiles}/>
                {loading ? (
                    <div style={{
                        height: 800,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '10px',
                        margin: '20px',
                        overflow: 'hidden'
                    }}>
                        <LoaderCustomFixed style={{color: '#d3d3d3'}}/> {/* Customizing loader color to light gray */}
                    </div>

                ) : (

                    <div>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="სახელით ძიება..."
                            variant="outlined"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{margin: '20px 0'}}
                        />
                        <TableContainer component={Paper}
                                        style={{
                                            marginTop: 20,
                                            marginBottom: 20,
                                            minHeight: 800,
                                            maxHeight: 800,
                                            overflowY: 'auto'
                                        }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 100
                                        }}>სახელი</TableCell>
                                        <TableCell style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 100
                                        }}>ნომენკლატურა</TableCell>
                                        <TableCell style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 100
                                        }}>ქმედება</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documentTypes
                                        .filter(docType => docType.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                        .map((docType) => (
                                            <TableRow key={docType.id}>
                                                <TableCell>
                                                    {docType.name}
                                                </TableCell>
                                                <TableCell>{getDepartmentNames(docType.departamentIds)}</TableCell>

                                                <TableCell>
                                                    <div style={{display: "flex", justifyContent: "center", gap: 10}}>
                                                        <Tooltip title="რედატირება" enterDelay={500} leaveDelay={200}>
                                                            <IconButton
                                                                onClick={() => openEditModal(docType)}
                                                            >
                                                                <MdEdit color="#1976d2"/>
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="წაშლა" enterDelay={500} leaveDelay={200}>
                                                            <IconButton
                                                                onClick={() => openDeleteModal(docType.id)}
                                                            >
                                                                <MdDelete color="#d32f2f"/>
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="დუბლირება" enterDelay={500} leaveDelay={200}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    setDocTypeToCopy(docType);
                                                                    setIsDocCopyModalOpen(true);
                                                                }}

                                                            >
                                                                <HiOutlineClipboardDocument color="green"/>
                                                            </IconButton>
                                                        </Tooltip>

                                                    </div>

                                                </TableCell>
                                            </TableRow>
                                        ))}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                )}
            </div>
            <Dialog
                open={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    style: {
                        width: '1500px',
                        maxWidth: '1500px',
                        minHeight: 800
                    }
                }}
            >
                {isSubmitting ? (
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <CircularProgress size={100}/>
                    </div>

                ) : currentDocumentType ? (
                    <>
                        <div>
                            <div>
                                <DialogContent>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        label="სახელი"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={currentDocumentType?.name}
                                        onChange={(e) => setCurrentDocumentType({
                                            ...currentDocumentType,
                                            name: e.target.value
                                        })}
                                    />
                                    <FormControl fullWidth sx={{my: 2}}>
                                        <InputLabel id="doc-type-label">შაბლონის ტიპი</InputLabel>
                                        <Select
                                            labelId="doc-type-label"
                                            id="doc-type-select"
                                            value={currentDocumentType?.templateType}
                                            label="შაბლონის ტიპი"
                                            onChange={(e) => setCurrentDocumentType({
                                                ...currentDocumentType,
                                                templateType: e.target.value
                                            })}
                                        >
                                            {TemplateOptions.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <div style={{display: "flex", justifyContent: "center"}}>
                                    <JoditEditor
                                        value={currentDocumentType?.textHTML}
                                        tabIndex={1}
                                        config={config}
                                        onBlur={(newText) => handleContentChange(newText)}
                                        onBlur={newText => setCurrentDocumentType({
                                            ...currentDocumentType,
                                            textHTML: newText
                                        })}
                                    />
                                    <InstructionsBox/>
                                    </div>
                                    {
                                        currentDocumentType.documentTypeStatus === 1 && (
                                            <FormControl fullWidth sx={{my: 2}}>
                                                <InputLabel id="order-decision-label">დადასტურების ტიპი</InputLabel>
                                                <Select
                                                    labelId="order-decision-label"
                                                    id="order-decision-select"
                                                    value={currentDocumentType?.orderDecision}
                                                    label="დადასტურების ტიპი"
                                                    onChange={(e) => setCurrentDocumentType({
                                                        ...currentDocumentType,
                                                        orderDecision: e.target.value
                                                    })}
                                                >
                                                    {Object.values(OrderDecisionEnum).map((decision) => (
                                                        <MenuItem key={decision.id} value={decision.id}>
                                                            {decision.title}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        )
                                    }
                                    <Box sx={{mt: 2}}>
                                        {Object.values(DepartmentEnumWithoutLegal).map(department => (
                                            <FormControlLabel
                                                key={department.id}
                                                control={
                                                    <Checkbox
                                                        checked={selectedDepartments.includes(department.id)}
                                                        onChange={() => handleCheckboxChange(department.id)}
                                                    />
                                                }
                                                label={department.name}
                                            />
                                        ))}
                                    </Box>


                                    <FormControlLabel control={<Checkbox
                                        checked={editSkipVisage}
                                        onChange={handelSkipVisageChange}
                                    />}
                                                      label="ვიზირების გამოტოვება"/>
                                </DialogContent>
                            </div>

                        </div>
                        <DialogActions>
                            <Button onClick={() => setIsEditModalOpen(false)} color="primary">
                                გაუქმება
                            </Button>
                            <Button
                                disabled={currentDocumentType.name === "" || (currentDocumentType.documentTypeStatus === 1 && currentDocumentType.orderDecision === null) || selectedDepartments.length === 0}
                                onClick={handleUpdateDocumentType} color="primary">
                                შენახვა
                            </Button>
                        </DialogActions>
                    </>

                ) : (<div></div>)}


            </Dialog>

            <ConfirmationModal
                isOpen={isDeleteModalOpen}
                onRequestClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
            />

            <ConfirmationModal
                isOpen={isDocCopyModalOpen}
                onRequestClose={() => setIsDocCopyModalOpen(false)}
                onConfirm={() => copyDocument(docTypeToCopy)}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>
    );
};

export default AddNewDocumentTypeForm;
